import ko from './knockout-3.5.0';
import $ from './jquery-2.2.0';
import { $cookie } from './jquery.cookie-1.4.1';
import './radresponder.polyfills';
import './radresponder';
import _ from './underscore';

window.RadResponder = window.RadResponder || {};
const rr = window.RadResponder;

var currentUserInfo = ko.observable();
var pendingAdditionalInformationGuid = ko.observable(null);
var selectedEvent = ko.observable((function () {
    var cookie = $cookie("selected-event");
    if (cookie === null || cookie === undefined) {
        return null;
    }

    var se = JSON.parse($cookie("selected-event"));
    if (!se || !se.hasOwnProperty("id")) {
        return null;
    }

    return se;
})());
var selectedOrganization = ko.observable((function () {
    var cookie = $cookie("selected-organization");
    if (cookie === null || cookie === undefined) {
        return null;
    }

    var se = JSON.parse($cookie("selected-organization"));
    if (!se || !se.hasOwnProperty("id")) {
        return null;
    }

    return se;
})());
var lastServerAuthenticationCheckResult = ko.observable(null);

var eventPermissions = {};
var organizationPermissions = {};
var personnelPermissions = {};
var adminPermissions = {};
var organizationHazardTypeIds = {};
var laboratoryPermissions = {};
var modulePermissions = {};
var saveEventSelection = function (e) {
    //save the event selection to a cookie
    $cookie("selected-event", JSON.stringify(e), { path: "/" });

    //set observable
    selectedEvent(e);
};

var organizationCollectableDataTypes = {};

// datetime calculation set
var regexDateOnly = /^((m|M){1,2}|(d|D){1,2}|(y|Y){2,4})\/((m|M){1,2}|(d|D){1,2}|(y|Y){2,4})(\/((m|M){1,2}|(d|D){1,2}|(y|Y){2,4}))?$/;
var isUserPreferenceInLocalTime = function () {
    return currentUserInfo() ? currentUserInfo().displayDateTimeInLocalTimeZone : true;
};
var isFormatDateOnly = function (parameterFormat) {
    return parameterFormat && regexDateOnly.test(parameterFormat);
};
var isDateTimeLocal = function (parameterFormat) {
    return isUserPreferenceInLocalTime() && !isFormatDateOnly(parameterFormat); //never local if dateTimeFormat is date only
};
var getDateTimeAsMoment = function (parameterDateTime, parameterFormat, isDateStringLocal) {
    var displayInLocalTime = isDateTimeLocal(parameterFormat),
        result;

    // if null, return null
    if (parameterDateTime === null) {
        return null;
    }

    // if undefined, return current date and time
    if (parameterDateTime === undefined) {
        return displayInLocalTime ? moment() : moment.utc();
    }

    if (typeof parameterDateTime === 'string' || parameterDateTime instanceof String) {
        if (typeof isDateStringLocal === 'boolean') {
            result = isDateStringLocal === true ? moment(parameterDateTime, parameterFormat) : moment.utc(parameterDateTime, parameterFormat);
        } else {
            result = moment.utc(parameterDateTime, parameterFormat);
        }
    } else {
        result = displayInLocalTime ? moment(parameterDateTime, parameterFormat) : moment.utc(parameterDateTime, parameterFormat);
    }

    if (displayInLocalTime) {
        result.local();
    } else {
        result.utc();
    }

    return result;
};
var getDateTimeAsString = function (parameterDateTime, parameterFormat) {
    var displayInLocalTime = isDateTimeLocal(parameterFormat),
        format = parameterFormat || rr.formats.DateTime,
        dateTime = moment.isMoment(parameterDateTime) ? parameterDateTime : moment.utc(parameterDateTime);

    if (!dateTime) {
        return null;
    }

    return displayInLocalTime ? dateTime.local().format(format) : dateTime.format(format);
};
var getDisplayDateTime = function (parameterDateTime, parameterFormat) {
    var displayInLocalTime = isDateTimeLocal(parameterFormat),
        result = getDateTimeAsString(parameterDateTime, parameterFormat);

    // don't append 'UTC' if it's date only
    return displayInLocalTime || isFormatDateOnly(parameterFormat) ? result : (result + " UTC");
};
var getDateTimeAsUtcString = function (parameterDateTime, parameterFormat) {
    var format = parameterFormat || rr.formats.DateTime,
        dateTime = moment.utc(parameterDateTime);

    if (parameterDateTime === null || !dateTime) {
        return null;
    }

    return dateTime.format(format);
};
var getDateTimeAsLocalString = function (parameterDateTime, parameterFormat) {
    var format = parameterFormat || rr.formats.DateTime,
        dateTime = moment.utc(parameterDateTime);

    if (parameterDateTime === null || !dateTime) {
        return null;
    }

    return dateTime.local().format(format);
};
var updateDisplayDateTimePreference = function (newDateTimeUserPreference) {
    var priorUserInfo = currentUserInfo();

    if (priorUserInfo) {
        currentUserInfo($.extend(priorUserInfo, {
            displayDateTimeInLocalTimeZone: newDateTimeUserPreference
        }));
    }
};
var isDateInFuture = function (paramValue, isDateUtc) {
    var dateValue = moment.isMoment(paramValue) ? paramValue : (isDateUtc !== false ? moment.utc(paramValue) : moment(paramValue));

    return moment().isBefore(dateValue);
};
var isDateInPast = function (paramValue, isDateUtc) {
    var dateValue = moment.isMoment(paramValue) ? paramValue : (isDateUtc !== false ? moment.utc(paramValue) : moment(paramValue));

    return moment().isAfter(dateValue);
};
var minDateTime = function () {
    return moment.utc("01/01/2001");
};
var maxDateTime = function () {
    var offsetHours = Math.round(moment().utcOffset() / 60);

    return isDateTimeLocal() ? moment().add(1, "h") : moment().add(1 - offsetHours, "h");
};

var getPersonnelEventOptions = function (eventId) {
    var path = 'event/' + eventId + '/options';
    var getValueOrDefault = function (key, defaultValue) {
        var result = rr.Sessions().loadSetting(path, key);
        return result === undefined ? defaultValue : result;
    }
    return {
        hideSeverity: getValueOrDefault('hideSeverity', false)
    }
};

var isSeverityHidden = function () {
    return router.activeInstruction().config.moduleId === 'event/index' &&
        getPersonnelEventOptions(selectedEvent().id).hideSeverity;
};

var hideSeverity = function (value) {
    return isSeverityHidden() ? '<em>Hidden</em>' : value;
};

var updateGPSLocationFormatPreference = (newGPSLocationFormatId) => {
    var priorUserInfo = currentUserInfo();

    if (priorUserInfo) {
        currentUserInfo($.extend(priorUserInfo, {
            gpsLocationFormatId: newGPSLocationFormatId
        }));
    }
};

var getGPSLocationFormat = () => {
    return currentUserInfo() ? currentUserInfo().gpsLocationFormatId : RadResponder.gpsLocationFormats.decimal;
};

var getFormattedLatLong = (decimalCoordsLat, decimalCoordsLong) => {
    let formatId = getGPSLocationFormat();

    switch (formatId) {
        case RadResponder.gpsLocationFormats.decimal:
            return RadResponder.toDecimalFormat(decimalCoordsLat, decimalCoordsLong);
        case RadResponder.gpsLocationFormats.degreesMinutes:
            return RadResponder.toDegreeMinute(decimalCoordsLat, decimalCoordsLong);
        case RadResponder.gpsLocationFormats.degreesMinutesSeconds:
            return RadResponder.toDegreeMinuteSecond(decimalCoordsLat, decimalCoordsLong);
        default:
            // Fallback to decimal format if format is unknown
            return RadResponder.toDecimalFormat(decimalCoordsLat, decimalCoordsLong);
    }
};

var getFormattedLatitude = (latitude, formatId) => {
    if (!formatId) {
        formatId = getGPSLocationFormat();
    }
    switch (formatId) {
        case RadResponder.gpsLocationFormats.decimal:
            return latitude.toFixed(6);
        case RadResponder.gpsLocationFormats.degreesMinutes:
            return RadResponder.convertToDegreeMinute(latitude, "N", "S");
        case RadResponder.gpsLocationFormats.degreesMinutesSeconds:
            return RadResponder.convertToDegreeMinuteSecond(latitude, "N", "S");
        default:
            return latitude.toFixed(6);
    }
};

var getFormattedLongitude = (longitude, formatId) => {
    if (!formatId) {
        formatId = getGPSLocationFormat();
    }
    switch (formatId) {
        case RadResponder.gpsLocationFormats.decimal:
            return longitude.toFixed(6);
        case RadResponder.gpsLocationFormats.degreesMinutes:
            return RadResponder.convertToDegreeMinute(longitude, "E", "W");
        case RadResponder.gpsLocationFormats.degreesMinutesSeconds:
            return RadResponder.convertToDegreeMinuteSecond(longitude, "E", "W");
        default:
            return longitude.toFixed(6);
    }
};

var sessionObj = {
    currentUserInfo: currentUserInfo,
    currentUser: ko.computed(function () {
        return currentUserInfo() ? currentUserInfo().displayAs : null;
    }),
    showChat: ko.computed(function () {
        return currentUserInfo() ? _.some(currentUserInfo().orgMemberships, function (m) { return m.chatEnabled === true; }) : true;
    }),
    canChat: function (id) {
        var deferred = $.Deferred();

        $.post(RadResponder.getApiAddress() + "/personnel/canchat/" + id).done(function (data) {
            deferred.resolve(data);
        });

        return deferred.promise();
    },
    currentUserPersonnelId: ko.computed(function () {
        return currentUserInfo() ? currentUserInfo().personnelId : null;
    }),
    pendingAdditionalInformationGuid: pendingAdditionalInformationGuid,
    isPendingAdditionalInformation: ko.computed(function () {
        return pendingAdditionalInformationGuid() !== null;
    }),
    additionalInformationLink: ko.computed(function () {
        return String.format("#account/statuschangerequest/{0}", pendingAdditionalInformationGuid());
    }),
    selectedEvent: selectedEvent,
    selectedOrganization: selectedOrganization,
    saveEventSelection: saveEventSelection,
    selectEvent: function (e, stopNav) {
        //check if current event is the same as selected event
        if (!selectedEvent() || (selectedEvent() && selectedEvent().id !== e.id)) {
            //save to cookie and reset dashboard
            saveEventSelection(e);
            //Clear out data stored for previous event
            localStorage.removeItem("createEventMergeModel");

            //save to server
            $.post(RadResponder.getApiAddress() + "event/saveeventselection/" + (e.id !== "live" ? e.id : ""));
        }

        if (!stopNav) {
            //go to the dashboard
            router.navigate("#event/" + e.id + "/dashboard");
        }
    },
    saveOrganizationSelection: function (e, dontRememberSelection) {
        if (!dontRememberSelection) {
            //save the event selection to a cookie
            $cookie("selected-organization", JSON.stringify(e), { path: "/" });
        }

        //set observable
        selectedOrganization(e);
    },
    selectOrganization: function (o, dontRememberSelection, stopNav) {
        //check if current org is the same as selected org
        if (!selectedOrganization() || (selectedOrganization() && selectedOrganization().id !== o.id)) {
            //save to cookie and reset dashboard
            this.saveOrganizationSelection(o, dontRememberSelection);

            if (!dontRememberSelection) {
                //save to server
                $.post(RadResponder.getApiAddress() + "organization/saveorganizationselection/" + o.id);
            }
        }

        if (!stopNav) {
            //go to dashboard
            router.navigate("organization/" + selectedOrganization().id + "/dashboard");
        }
    },

    isUserAuthenticatedToServer: function () {
        if (lastServerAuthenticationCheckResult()) {
            return true;
        }

        var deferred = $.Deferred();
        $.post(RadResponder.getApiAddress() + "account/isuserauthenticated")
            .done(function (data) {
                deferred.resolve(data);
            })
            .fail(function () {
                deferred.resolve(false);
            });
        return deferred.promise();
    },
    isUserAuthenticated: ko.computed(function () {
        return currentUserInfo() !== null && currentUserInfo() !== undefined;
    }),
    clearAuthentication: function () {
        selectedEvent = ko.observable(); //set to a new observable to clear dependencies
        selectedOrganization = ko.observable();

        //clear selection cookies
        $cookie("selected-event", null, { path: "/" });
        $cookie("selected-organization", null, { path: "/" });

        //Don't want to use null because refresh will also null out this.
        //clear user info
        currentUserInfo = ko.observable();
    },
    isEventSelected: function (id) {
        return selectedEvent() && parseInt(selectedEvent().id) === parseInt(id);
    },
    isOrganizationSelected: function (id) {
        return selectedOrganization() && parseInt(selectedOrganization().id) === parseInt(id);
    },

    clearSelectedEvent: function () {
        selectedEvent(null);
        $cookie("selected-event", null, { path: "/" });
    },
    clearSelectedOrganization: function () {
        selectedOrganization(null);
        $cookie("selected-organization", null, { path: "/" });
    },

    hasPermission: function (permissions, permission) {
        var perms = ko.utils.unwrapObservable(permissions);
        return _.contains(perms, permission);
    },

    canRequestMembershipToAnotherOrg: function () {
        return currentUserInfo() && !currentUserInfo().isTemporary && !currentUserInfo().isForeign && !currentUserInfo().isShared;
    },
    isForeign: ko.computed(function () {
        return currentUserInfo() ? currentUserInfo().isForeign : false;
    }),
    hasOrganizationWithEventAccess: ko.computed(function () {
        return currentUserInfo() ? _.some(currentUserInfo().orgMemberships, function (i) { return i.eventEnabled === true; }) : false;
    }),
    doesOrganizationSupportEvents: function (orgId) {
        return currentUserInfo() ? _.some(currentUserInfo().orgMemberships, function (i) { return i.id === parseInt(orgId) && i.eventEnabled === true; }) : true;
    },
    hasOrganizationWithLaboratoryAccess: ko.computed(function () {
        return currentUserInfo() && currentUserInfo().orgMemberships ? _.some(currentUserInfo().orgMemberships, function (i) { return i.labEnabled === true; }) : false;
    }),
    getEventPermissions: function (id) {
        return this.getPermissions(id, eventPermissions, "event");
    },
    getOrganizationPermissions: function (id) {
        return this.getPermissions(id, organizationPermissions, "organization");
    },
    getLaboratoryPermissions: function (id) {
        return this.getPermissions(currentUserInfo().personnelId, laboratoryPermissions, "laboratory");
    },
    getModulePermissions: function (id) {
        return this.getPermissions(id, modulePermissions, 'module');
    },
    getImaacModulePermissions: function () {
        return this.getModulePermissions(RadResponder.modules.imaac);
    },
    canViewStandardImaacNavigationItem: function (imaacModulePermissions) {
        return this.hasPermission(imaacModulePermissions, "ImaacViewStandardNavigationItem");
    },
    canViewAdminImaacNavigationItem: function (imaacModulePermissions) {
        return this.hasPermission(imaacModulePermissions, "ImaacViewAdminNavigationItem");
    },
    getOrganizationPermissionsForEquipment: function (id) {
        var deferred = $.Deferred();
        return deferred.then($.post(RadResponder.getApiAddress() + "organization/getpermissionsforequipment/" + id)
            .done(function (data) {
                deferred.resolve(data);
            }));
    },
    getOrganizationPermissionsForEquipmentTemplate: function (id) {
        let deferred = $.Deferred();
        return deferred.then($.post(RadResponder.getApiAddress() + "organization/getpermissionsforequipment/template/" + id)
            .done(function (data) {
                deferred.resolve(data);
            }));
    },
    getOrganizationPermissionsForFacility: function (id) {
        var deferred = $.Deferred();
        return deferred.then($.post(RadResponder.getApiAddress() + "organization/getpermissionsforfacility/" + id)
            .done(function (data) {
                deferred.resolve(data);
            }));
    },
    getPersonnelPermissions: function (id) {
        return this.getPermissions(id, personnelPermissions, "personnel");
    },
    getAdministrationPermissions: function () {
        return this.getPermissions(null, adminPermissions, "admin");
    },
    getPermissions: function (id, permissionSet, objectType) {
        var key = id || id === 0 ? id.toString() : "";

        //pull cached version if we have pulled previously
        var deferred = $.Deferred();
        if (permissionSet[key]) {
            deferred.resolve(permissionSet[key]);
            return deferred.promise();
        }

        //check if user has access to edit event
        return deferred.then($.post(rr.getApiAddress() + objectType + "/getpermissions/" + (key === "live" ? "" : key))
            .done(function (data) {
                //save it before returning it
                permissionSet[key] = data;

                deferred.resolve(data);
                return deferred.promise();
            }));

    },

    getOrganizationCollectableDataTypes: function (id) {
        var key = id || id === 0 ? id.toString() : "";

        //pull cached version if we have pulled previously
        var deferred = $.Deferred();
        if (organizationCollectableDataTypes[key]) {
            deferred.resolve(organizationCollectableDataTypes[key]);
            return deferred.promise();
        }

        //check if user has access to edit event
        return deferred.then($.post(rr.getApiAddress() + "organization/hazardtypes/getcollectabledatatypes/" + key)
            .done(function (data) {
                organizationCollectableDataTypes[key] = data;

                deferred.resolve(data);
                return deferred.promise();
            }));
    },
    invalidateOrganizationCollectableDataTypes: function (id) {
        var key = id || id === 0 ? id.toString() : "";
        organizationCollectableDataTypes[key] = null;
    },

    hasSystemRole: function (role) {
        return currentUserInfo() && currentUserInfo().systemRoles && currentUserInfo().systemRoles.indexOf(role) >= 0;
    },
    hasSystemRoleId: function (role) {
        return currentUserInfo() && currentUserInfo().systemRoleIds && currentUserInfo().systemRoleIds.indexOf(role) >= 0;
    },

    hasGlobalPermission: function (permission) {
        return currentUserInfo() && currentUserInfo().globalPermissions && currentUserInfo().globalPermissions.indexOf(permission) >= 0;
    },
    hasGlobalPermissionId: function (permissionId) {
        return currentUserInfo() && currentUserInfo().globalPermissionIds && currentUserInfo().globalPermissionIds.indexOf(permissionId) >= 0;
    },

    getOrganizationHazardTypeIds: function (id) {
        var key = id || id === 0 ? id.toString() : "";

        key = key || (selectedOrganization && selectedOrganization() ? selectedOrganization().id : "");

        //pull cached version if we have pulled previously
        var deferred = $.Deferred();
        if (organizationHazardTypeIds[key]) {
            deferred.resolve(organizationHazardTypeIds[key]);
            return deferred.promise();
        }

        //check if user has access to edit event
        return deferred.then($.post(rr.getApiAddress() + "organization/hazardtypes/" + key)
            .done(function (data) {
                var results = _.map(data, function (item) {
                    return item.Hazard_Type_Id;
                });

                //save it before returning it
                organizationHazardTypeIds[key] = results;

                deferred.resolve(results);
                return deferred.promise();
            }));
    },

    canViewDosimetry: ko.observable(false),

    isDateTimeLocal: isDateTimeLocal,
    getDisplayDateTime: getDisplayDateTime,
    getDateTimeAsString: getDateTimeAsString,
    getDateTimeAsUtcString: getDateTimeAsUtcString,
    getDateTimeAsLocalString: getDateTimeAsLocalString,
    getDateTime: getDateTimeAsMoment,
    maxDateTime: maxDateTime,
    minDateTime: minDateTime,
    updateDisplayDateTimePreference: updateDisplayDateTimePreference,
    isDateInFuture: isDateInFuture,
    isDateInPast: isDateInPast,
    isUserPreferenceInLocalTime: isUserPreferenceInLocalTime,
    isSeverityHidden: isSeverityHidden,
    hideSeverity: hideSeverity,
    updateGPSLocationFormatPreference: updateGPSLocationFormatPreference,
    getGPSLocationFormat: getGPSLocationFormat,
    getFormattedLatLong: getFormattedLatLong,
    getFormattedLatitude: getFormattedLatitude,
    getFormattedLongitude: getFormattedLongitude
};

rr.session = sessionObj;

export default sessionObj;